import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'

import p1min from '../assets/img/portfolio/p1min-min.jpg'
import p2min from '../assets/img/portfolio/p2min-min.jpg'
import p3min from '../assets/img/portfolio/p3min-min.jpg'
import p4min from '../assets/img/portfolio/p4min-min.jpg'
import p5min from '../assets/img/portfolio/p5min-min.jpg'
import p6min from '../assets/img/portfolio/p6min-min.jpg'
import p7min from '../assets/img/portfolio/p7min-min.jpg'
import p8min from '../assets/img/portfolio/p8min-min.jpg'
import p9min from '../assets/img/portfolio/p9min-min.jpg'
import p10min from '../assets/img/portfolio/p10min-min.jpg'
import p11min from '../assets/img/portfolio/p11min-min.jpg'
import p12min from '../assets/img/portfolio/p12min-min.jpg'
import p13min from '../assets/img/portfolio/p13min-min.jpg'
import p14min from '../assets/img/portfolio/p14min-min.jpg'
import p15min from '../assets/img/portfolio/p15min-min.jpg'


const Portfolio = (props) => {
  const arrImgmin = [ p1min, p2min, p3min, p4min, p5min, p6min, p7min, p8min, p9min, p10min, p11min, p12min, p13min, p14min, p15min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/p1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p6.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p7.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p8.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p9.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p10.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p11.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p12.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p13.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p14.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/p15.jpg'} 
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/' >
      <Trans i18nKey='portfolio'>
        <p>Наша команда допоможе внести у Ваше життя красу природи, подих свіжого повітря, дотик зелені та незабутність квіткових вражень.</p>
        <p className="prise">Ваші найсміливіші побажання – це наш виклик, наш ріст і наше вдосконалення!</p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(Portfolio)


// WEBPACK FOOTER //
// ./src/page/portfolio.jsx